const initialState = {
    loading: false,
    selected: null,
    data: undefined
};

export default initialState;